export default __webpack_public_path__ + "static/media/wpmtest_preex.d0f3cb50.svg";